import React, { useEffect, useState } from "react";
import {
  Card,
  Avatar,
  Typography,
  Space,
  Button,
  Row,
  Col,
  theme,
  Upload,
  Drawer,
  Form,
  Input,
  message,
  Dropdown,
  Divider,
  Modal,
  Empty,
} from "antd";
import {
  DownloadOutlined,
  DeleteOutlined,
  UploadOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  CheckCircleOutlined,
  MoreOutlined,
  EditOutlined,
  UserOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeAPI } from "CommonComponents/Lookup/LookupAPI";
import FormType from "features/Enums/FormType";
import {
  addLeadEmailAPI,
  deleteLeadEmailByIdAPI,
  editLeadEmailAPI,
  getLeadEmailsListAPI,
} from "../LeadsAPI";
import { useParams } from "react-router-dom";
import useSelection from "antd/es/table/hooks/useSelection";
import { useForm } from "antd/es/form/Form";
import { FormattedMessage, useIntl } from "react-intl";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import dayjs from "dayjs";
import InfiniteScroll from "react-infinite-scroller";

function EmailTab() {
  const { token } = theme.useToken();
  const { Text, Title } = Typography;
  const intl = useIntl();
  const dispatch = useDispatch();
  const { TextArea } = Input;
  const [form] = useForm();
  const { leadId } = useParams();
  const { Dragger } = Upload;
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentEmail, setCurrentEmail] = useState(null);
  const leadEmailList = useSelector((state) => state.leads.leadEmailsList);
  const employeeList = useSelector((state) => state.lookup.employesList);
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadEmails"
  )?.id;
  useEffect(() => {
    if (leadId) {
      dispatch(getEmployeeAPI());
      setPage(1);
      setHasMore(true);
      // loadMoreData(1);
    }
  }, [leadId]);
  const values = {
    pageNo: page,
    pageSize: 10,
    searchQuery: "",
  };
  const loadMoreData = (explicitPage) => {
    const currentPage = explicitPage || page;
    if (loading || !hasMore) return;
    setLoading(true);

    dispatch(getLeadEmailsListAPI(leadId, values))
      .then((res) => {
        const items = res?.payload?.items || [];
        const totalPages = res?.payload?.totalPages;
        const currentPage = res?.payload?.pageNumber;

        if (currentPage >= totalPages || items.length === 0) {
          setHasMore(false);
        } else {
          setPage((prev) => prev + 1);
        }
      })
      .finally(() => setLoading(false));
  };

  const getEmployeeNameById = (employeeId) => {
    const employee = employeeList?.find((item) => item?.id === employeeId);
    return employee
      ? `${employee.firstName} ${employee.lastName}`
      : "Unknown User";
  };
  const showDrawer = (email = null) => {
    setCurrentEmail(email);
    if (email) {
      form.setFieldsValue({
        subject: email.subject,
        bodyOfMail: email.bodyOfMail,
      });
    } else {
      form.resetFields();
    }
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    dispatch(getLeadEmailsListAPI(leadId, values));
  };
  const handleSubmit = async (values) => {
    const emailObj = {
      id: currentEmail?.id || 0,
      leadId: leadId,
      subject: values.subject,
      bodyOfMail: values.bodyOfMail,
    };
    setLoading(true);
    try {
      if (currentEmail?.id) {
        await dispatch(editLeadEmailAPI(emailObj, leadId, values)).then(() => {
          setOpen(false);
          form.resetFields();
        });
      } else {
        await dispatch(addLeadEmailAPI(emailObj, leadId, values)).then(() => {
          setOpen(false);
          form.resetFields();
        });
      }
    } catch (error) {
      //message.error("Error saving note: " + (error.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };
  const onCancel = () => {
    if (form.isFieldsTouched()) {
      Modal.confirm({
        title: intl.formatMessage({ id: "LeadNote.CancelConfirmation" }),
        okText: intl.formatMessage({ id: "Common.Yes" }),
        cancelText: intl.formatMessage({ id: "Common.No" }),
        onOk: () => {
          form.resetFields();
          onClose();
        },
      });
    } else {
      onClose();
    }
  };

  const handleDelete = (emailId) => {
    Modal.confirm({
      title: intl.formatMessage({ id: "LeadMail.DeleteConfirm" }),
      okText: intl.formatMessage({ id: "Common.Yes" }),
      okType: "danger",
      cancelText: intl.formatMessage({ id: "Common.No" }),
      onOk() {
        dispatch(deleteLeadEmailByIdAPI(emailId, leadId, values));
      },
    });
  };

  const items = (email) => [
    {
      key: "edit",
      label: (
        <span>
          <EditOutlined />
          &nbsp;&nbsp;
          <FormattedMessage id="Common.Edit" />
        </span>
      ),
      onClick: () => showDrawer(email),
    },

    {
      key: "delete",
      label: (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleDelete(email.id);
          }}
        >
          <DeleteOutlined />
          &nbsp;&nbsp;
          <FormattedMessage id="Common.Delete" />
        </a>
      ),
    },
  ];
  return (
    <>
      <div size="small" className="notes-btn">
        <Button
          color="primary"
          variant="dashed"
          block
          className="mb-10 new-btn-add"
          onClick={() => showDrawer(null)}
        >
          <PlusCircleOutlined />
          {<FormattedMessage id="LeadMail.AddNewMail" />}
        </Button>
        <div style={{ maxHeight: "60vh", overflow: "auto" }}>
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMoreData}
            hasMore={!loading && hasMore}
            useWindow={false}
            threshold={100}
            loader={
              <div
                key="loader"
                style={{ textAlign: "center", padding: "1rem" }}
              >
                {<FormattedMessage id="Common.loading" />}
              </div>
            }
          >
            <Space direction="vertical" size={10} style={{ width: "100%" }}>
              {leadEmailList?.length > 0 ? (
                leadEmailList.map((email) => (
                  <Card key={email.id} className="activitytab">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      <Space align="start">
                        <Avatar
                          shape="square"
                          size={32}
                          icon={<MailOutlined style={{ color: "#624af2" }} />}
                          style={{
                            background: "#f0ebff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        />
                        <div>
                          <Text strong>{email.subject}</Text>
                          <p>{email.bodyOfMail}</p>
                          <AttachmentComponent
                            identifier={formTypeId}
                            currentId={email?.id}
                            isPreview={true}
                            getattachments={true}
                          />
                          <Text
                            type="secondary"
                            strong
                            className="username-new mt-10 f-11"
                          >
                            Sent by {getEmployeeNameById(email.createdBy)}
                            ,&nbsp;&nbsp;&nbsp;
                            {dayjs(email.createdDate).format(
                              "DD MMM YYYY, hh:mm a"
                            )}
                          </Text>
                        </div>
                      </Space>
                      <div className="activitytab-dropdown text-right">
                        <Dropdown
                          menu={{ items: items(email) }}
                          trigger={["click"]}
                        >
                          <Button onClick={(e) => e.preventDefault()}>
                            <MoreOutlined />
                          </Button>
                        </Dropdown>
                      </div>
                    </div>
                  </Card>
                ))
              ) : (
                <Card className="text-center">
                  <Empty description={false} />
                  <Text type="secondary">
                    {<FormattedMessage id="NoData" />}
                  </Text>
                </Card>
              )}
              {!hasMore && leadEmailList?.length > 0 && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "0",
                    color: "#999",
                  }}
                >
                  {<FormattedMessage id="Common.EndOfList" />}
                </div>
              )}
            </Space>
          </InfiniteScroll>
        </div>
      </div>
      <Drawer
        title={
          currentEmail ? (
            <FormattedMessage id="LeadMail.EditLeadMail" />
          ) : (
            <FormattedMessage id="LeadMail.AddNewMail" />
          )
        }
        onClose={onClose}
        open={open}
        width="500px"
      >
        <Form
          name="email-form"
          form={form}
          layout="vertical"
          autoComplete="off"
          size="large"
          onFinish={handleSubmit}
        >
          <Form.Item
            label={<FormattedMessage id="LeadMail.Subject" />}
            name="subject"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "LeadMail.Error.PleaseEntersubject",
                }),
              },
            ]}
          >
            <Input
              placeholder={intl.formatMessage({
                id: "LeadMail.Placeholder.Entersubject",
              })}
              maxLength={200}
            />
          </Form.Item>
          <Form.Item
            label={<FormattedMessage id="LeadMail.BodyMail" />}
            name="bodyOfMail"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "LeadMail.Error.PleaseEnterbodyMail",
                }),
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder={intl.formatMessage({
                id: "LeadMail.Placeholder.EnterbodyMail",
              })}
              maxLength={255}
              showCount
            />
          </Form.Item>
          <Form.Item
            label={<FormattedMessage id="Common.Attachment" />}
            name="attachment"
          >
            <AttachmentComponent
              identifier={formTypeId}
              currentId={currentEmail?.id}
              getattachments={true}
            />
          </Form.Item>
          <Row>
            <Col span={24} className="text-center mt-10">
              <Space>
                <Button
                  danger
                  variant="outlined"
                  size="medium"
                  onClick={onCancel}
                  disabled={loading}
                >
                  <CloseCircleOutlined />{" "}
                  {<FormattedMessage id="Common.Cancel" />}
                </Button>
                <Button
                  type="primary"
                  size="medium"
                  htmlType="submit"
                  loading={loading}
                >
                  <CheckCircleOutlined />{" "}
                  {<FormattedMessage id="Common.Save" />}
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Drawer>
      {/* </Card> */}
    </>
  );
}

export default EmailTab;
